import React from 'react';
import Login from 'components/website/auth/Login';

function LoginPage() {
  return <Login />;
}

export default LoginPage;
